"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stats = void 0;
var _core = require("@dragon/core");
var _pixi = require("pixi.js");
var _Counter = require("./Counter");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Stats = exports.Stats = /*#__PURE__*/function (_Container) {
  function Stats(parentContainer) {
    var _this;
    _classCallCheck(this, Stats);
    _this = _callSuper(this, Stats);
    _defineProperty(_this, "featuresWon", void 0);
    _defineProperty(_this, "roundCounter", void 0);
    _defineProperty(_this, "totalCoinsWonFeatures", void 0);
    _defineProperty(_this, "bgRect", void 0);
    _defineProperty(_this, "background", void 0);
    _defineProperty(_this, "biggestwin", void 0);
    _defineProperty(_this, "handleResize", function (c) {
      if (c.channel === _core.Channel.Mobile) {
        if (c.orientation == _core.Orientation.Portrait) {
          var scale = 0.6;
          if (c.width > 760) {
            scale = 1;
          }
          _this.roundCounter.scale.set(scale);
          _this.roundCounter.x = c.width * 0.8;
          _this.roundCounter.y = c.height * 0.6;
          _this.biggestwin.scale.set(scale);
          _this.biggestwin.x = c.width * 0.2;
          _this.biggestwin.y = c.height * 0.6;
          _this.featuresWon.visible = false;
          _this.totalCoinsWonFeatures.visible = false;
        } else {
          var _scale = c.scaleFactor / 0.68;
          if (c.height > 760) {
            _scale = 1;
          }
          _this.biggestwin.scale.set(_scale);
          _this.biggestwin.x = c.width * 0.75;
          _this.biggestwin.y = c.height * 0.2;
          _this.roundCounter.scale.set(_scale);
          _this.roundCounter.x = c.width * 0.25;
          _this.roundCounter.y = c.height * 0.2;
          _this.featuresWon.visible = true;
          _this.featuresWon.scale.set(_scale);
          _this.featuresWon.x = c.width * 0.25;
          _this.featuresWon.y = c.height * 0.75;
          _this.totalCoinsWonFeatures.visible = true;
          _this.totalCoinsWonFeatures.scale.set(_scale);
          _this.totalCoinsWonFeatures.x = c.width * 0.75;
          _this.totalCoinsWonFeatures.y = c.height * 0.75;
        }
      } else {
        _this.biggestwin.x = c.width / 2 - 400 * c.scaleFactor;
        _this.biggestwin.y = c.height * 0.7;
        _this.biggestwin.scale.set(c.scaleFactor);
        _this.roundCounter.x = c.width / 2 + 400 * c.scaleFactor;
        _this.roundCounter.y = c.height * 0.7;
        _this.roundCounter.scale.set(c.scaleFactor);
        _this.featuresWon.x = c.width / 2 + 150 * c.scaleFactor;
        _this.featuresWon.y = c.height * 0.7;
        _this.featuresWon.scale.set(c.scaleFactor);
        _this.totalCoinsWonFeatures.x = c.width / 2 - 150 * c.scaleFactor;
        _this.totalCoinsWonFeatures.y = c.height * 0.7;
        _this.totalCoinsWonFeatures.scale.set(c.scaleFactor);
      }
    });
    var headerStyle = new _pixi.TextStyle({
      fontSize: 18,
      fill: ["#ffffff"],
      // gradient
      stroke: "#000000",
      strokeThickness: 3,
      fontFamily: ["LocaleFontRegular", "NotoSansJPRegular", "InterMedium", "RoundedMplusRegular", "Helvetica", "Arial", "sans-serif"]
    });
    var valueStyle = {
      fontName: "blitzgoldbm",
      fontSize: 100,
      letterSpacing: -32,
      align: "left"
    };
    _this.name = "statsContainer";
    _this.roundCounter = new _Counter.Counter(_this, new _pixi.Sprite(_pixi.Texture.from("bi_rounds.png")), "blitz.roundsPlayed", "blitzroundcount", headerStyle, valueStyle);
    _this.biggestwin = new _Counter.Counter(_this, new _pixi.Sprite(_pixi.Texture.from("bi_win.png")), "blitz.biggestWin", "blitzbiggestwin", headerStyle, valueStyle, true);
    _this.featuresWon = new _Counter.Counter(_this, new _pixi.Sprite(_pixi.Texture.from("bi_bonusrounds.png")), "blitz.featuresWon", "blitzfeaturecount", headerStyle, valueStyle);
    _this.totalCoinsWonFeatures = new _Counter.Counter(_this, new _pixi.Sprite(_pixi.Texture.from("bi_bonuswin.png")), "blitz.totalWonFeatures", "blitzcoinswoninfeature", headerStyle, valueStyle, true);
    parentContainer.addChild(_this);
    _core.CORE.subscribe("config.screenSize", _this.handleResize);
    return _this;
  }
  _inherits(Stats, _Container);
  return _createClass(Stats);
}(_pixi.Container);
//# sourceMappingURL=Stats.js.map